// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"components-base-NumberCounter-NumberCounter__numberInput--1f6H5"};